<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.georeference}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="product.title | safeHtml"></span>
	</h5>
</div>
<div class="modal-body d-flex flex-column" style="height: 80vh;">
	<div class="row">
		<div class="col-md-12 col-sm-12">
			<span class="help-block" style="display:inline-block; padding-left:14px; margin:15px 0;">
				{{ LOCALIZATION.georeferenceHelp }}
			</span>
		</div>
	</div>
    <form>
    	<div class="row">
    		<div class="col-md-6 col-sm-6">
		        <div class="form-group col-md-6 col-sm-6">
		            <label for="georefX">{{LOCALIZATION.imagePointX}}</label>
		            <input [(ngModel)]="georef.x" class="form-control" id="georefX" name="georefX" />
		        </div>
		        <div class="form-group col-md-6 col-sm-6">
		            <label for="georefY">{{LOCALIZATION.imagePointY}}</label>
		            <input [(ngModel)]="georef.y" class="form-control" id="georefY" name="georefY" />
		        </div>
	        </div>
	        <div class="col-md-6 col-sm-6">
		        <div class="form-group col-md-6 col-sm-6">
		            <label for="georefLon">{{LOCALIZATION.longitude}}</label>
		            <input [(ngModel)]="georef.lon" class="form-control" id="georefLon" name="georefLon" />
		        </div>
		        <div class="form-group col-md-6 col-sm-6">
		            <label for="georefLat">{{LOCALIZATION.latitude}}</label>
		            <input [(ngModel)]="georef.lat" class="form-control" id="georefLat" name="georefLat" />
		        </div>
	        </div>
        </div>
        <div class="row">
        	<div class="col-md-12 col-sm-12 centerMeta primary-controls">
        		<button type="submit" class="btn btn-default" [ngClass]="{ 'btn-accent' : readyToAdd }" (click)="addPoint()">{{LOCALIZATION.addPoint}}</button>
       		 	<button class="btn btn-default" (click)="showPoints = !showPoints">
       		 	 	{{LOCALIZATION.viewPoints}} <i class="fa" [ngClass]="{ 'fa-caret-up' : showPoints, 'fa-caret-down' : !showPoints }"></i>
       		 	</button>
				<div id="mapLocatorToolbar" style="display:inline-block;">
		            <form class="navbar-form" style="display:inline-block; padding:0px 0px;">
		                <div class="dropdown" ngbDropdown>
		                    <button id="basemap-menu-button" class="btn btn-default dropdown-toggle" ngbDropdownToggle title="Select a base layer" aria-label="Select a base layer">
		                        <i class="fas fa-layer-group"></i>
		                    </button>
		                    <ul class="dropdown-menu custom-drop" ngbDropdownMenu aria-labelledby="basemap-menu-button" role="menu">
		                        <li class="pointMe" *ngFor="let basemap of basemapConfigs" (click)="changeBasemap(basemap.name)">
		                        	<a style="color: #26a69a;">{{basemap.displayName}}</a>
		                        </li>
		                    </ul>
		                </div>
		            </form>
		            <form class="navbar-form" style="display:inline-block; padding:0px 0px;">
		                <div class="dropdown" ngbDropdown auto-close="disabled">
		                    <button id="search-coordinates-menu-button" class="btn btn-default dropdown-toggle" ngbDropdownToggle title="{{LOCALIZATION.searchGazeteer}}" [attr.aria-label]="LOCALIZATION.searchGazeteer">
		                        <i class="fa fa-search"></i>
		                    </button>
		                    <div class="dropdown-menu map-search" ngbDropdownMenu aria-labelledby="search-coordinates-menu-button" role="menu" style="height:auto; padding:10px;">
		                    	<div class="text-center"><span class="text-bold">{{LOCALIZATION.searchCoordinates}}</span></div>
		                        <br>
		                        <div class="row">
		                        	<div class="col-xs-12">
			                            <div>
			                                <div class="input-group">
			                                    <div class="input-group-addon">{{LOCALIZATION.longitude}}</div>
			                                    <input type="number" class="form-control" [(ngModel)]="search.x" name="longitude" aria-label="Longitude" />
			                                </div>
			                            </div>
			                            <div>
			                                <div class="input-group">
			                                    <div class="input-group-addon">{{LOCALIZATION.latitude}}</div>
			                                    <input type="number" class="form-control" [(ngModel)]="search.y" name="latitude" aria-label="Latitude" />
			                                </div>
			                            </div>
			                            <div>
			                                <button class="btn btn-default btn-md pull-right" (click)="zoomTo()"><i class="fa fa-search"></i></button>
			                            </div>
		                            </div>
		                        </div>
		                        <hr>
		                        <div class="text-center"><span class="text-bold">{{LOCALIZATION.searchGazeteer}}</span></div>
		                        <br>
		                        <div class="row" >
		                            <div id="locationHolder" class="col-xs-12"><div id="locationBar"></div></div>
		                        </div>
		                    </div>
		                </div>
		            </form>
		        </div>         		 	
       	 </div>
        </div>
    </form>
    <div class="row">
    	<div id="georeference-image" class="col-sm-6" style="height: 61vh">

			 <angular-cropper #angularCropper
			   [cropperOptions]="cropperConfig"
			   [imageUrl]="imageURL">
			 </angular-cropper>

    	</div>
    	<div id="esri-georeference-map-container" class="col-sm-6" style="padding:0; margin:0; height:61vh; position:relative;">
    
			<div #mapContainer id='mapViewDiv' class="flex-grow-1 w-100" style="height:100%; margin:0; padding:0;"></div>
  
    	</div>
    </div>
    <div class="background-white" [hidden]="!showPoints"
    	style='width:100%; position: absolute; overflow:auto; bottom: 8px; left: 0; right: 0; height: 35vh; z-index:999; border-top:1px solid #eee'>
        <div class="col-xs-12" style="overflow:auto; height:100%">
            <span class="text-bold help-block">{{ points.length }} points in use - Georeference is {{ points.length >= 3 ? 'valid' : 'invalid. Use a minimum of 3 points.' }}</span>
<!--             <span *ngIf="points && points.length === 0" class="text-bold help-block warning">{{LOCALIZATION.pointsEmpty}}</span> -->
            
            <table class="table table-striped table-bordered" *ngIf="points && points.length > 0" style="margin: 8px 0 0 0;">
                <thead>
                <tr>
                    <th>{{LOCALIZATION.imagePointX}}</th>
                    <th>{{LOCALIZATION.imagePointY}}</th>
                    <th>{{LOCALIZATION.longitude}}</th>
                    <th>{{LOCALIZATION.latitude}}</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let point of points; let i = index;">
                    <td>{{point.x}}</td>
                    <td>{{point.y}}</td>
                    <td>{{point.lon}}</td>
                    <td>{{point.lat}}</td>
                    <td><button class="btn btn-default btn-xs" (click)="removePoint(i)">{{LOCALIZATION.remove}}</button></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="modal-footer">
	<button class="btn btn-default" (click)="close()">{{LOCALIZATION.close}}</button>
    <button class="btn btn-primary" (click)="georeference()" [disabled]="!points || points.length === 0 || inprogress">
    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
    	{{LOCALIZATION.georeference}}
    </button>
</div>
